/*
 * Collection Banner
 *
 * The description is clamped to 2 lines by default (see section-collection-banner.css).
 * This only reveals the "Show more" toggle when the text actually overflows that
 * clamp, so a short description never gets a pointless button.
 */
if (!customElements.get('collection-description')) {
  customElements.define(
    'collection-description',
    class CollectionDescription extends HTMLElement {
      connectedCallback() {
        this.description = this.querySelector('.collection-banner__description');
        this.toggle = this.querySelector('.collection-banner__description-toggle');
        if (!this.description || !this.toggle) return;

        this.showMoreText = this.toggle.dataset.showMore || this.toggle.textContent;
        this.showLessText = this.toggle.dataset.showLess || this.toggle.textContent;

        this.onToggleClick = this.onToggleClick.bind(this);
        this.toggle.addEventListener('click', this.onToggleClick);

        // Layout needs a frame to settle (webfonts, etc.) before measuring overflow.
        requestAnimationFrame(() => this.revealToggleIfClamped());
      }

      revealToggleIfClamped() {
        if (this.description.scrollHeight - this.description.clientHeight > 1) {
          this.toggle.hidden = false;
        }
      }

      onToggleClick() {
        const expanded = !this.description.classList.contains('collection-banner__description--expanded');
        this.description.classList.toggle('collection-banner__description--expanded', expanded);
        this.toggle.setAttribute('aria-expanded', String(expanded));
        this.toggle.textContent = expanded ? this.showLessText : this.showMoreText;
      }
    }
  );
}
